import { render, staticRenderFns } from "./packageDescriptions.vue?vue&type=template&id=1fc9e650&"
import script from "./packageDescriptions.vue?vue&type=script&lang=js&"
export * from "./packageDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./packageDescriptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports